import React from 'react';
import styles from './EditLabel.module.scss';
import ActionsButton from '../../buttons/ActionsButton/ActionsButton';

export function EditLabel({ purpose, onClick, icon }) {
  return (
    <div className={styles.JobDetails__tag}>
      <div className={styles.tag}>{purpose}</div>
      {icon && <ActionsButton activityName="edit" clickHandler={onClick} />}
    </div>
  );
}
